module.exports = __webpack_public_path__ + "img/shift.cc3ec31c.svg";